import React, {useEffect} from 'react';

import { withRouter, useParams } from 'react-router-dom';
import { useStoreActions, useStoreState } from "easy-peasy";

function StartDemo(props) {
  const verifyAccount = useStoreActions(actions => actions.verifyAccount);
  const is_logged_in = useStoreState(state => state.is_logged_in);
  const {code} = useParams();

  useEffect(() => {
    if (is_logged_in) {
      props.history.push("/");
    }
    verifyAccount({code: code, password: ""})
    .then(response => {
      if (response.success) {
        props.history.push("/demo_instructions");
      } else if (response.errors) {
        window.alert(response.errors);
      }
    });
  }, [is_logged_in, props.history, code, verifyAccount]);

  return (
    <div className="row text-center pt-5 mt-5">
      <div className="col-12">
        <h1 className="font-weight-bold">Let's get <span className="text-danger">started.</span></h1>
        <div className="container mt-5 py-5">
          <div className="row d-flex">
            <ul>
              <li>Create an email with your desired content</li>
              <li>Send the email to <a href="mailto:dev@dev.linkoln.link">dev@dev.linkoln.link</a></li>
              <li>Receive a Linkoln Email link to your content.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(StartDemo);
